import * as React from "react";
import Calendar from "react-calendar";
import { useForm, useWatch, SubmitHandler, Controller } from "react-hook-form";

import { AppButton } from "components/AppButton";
import { TextField } from "components/TextField";
import styles from "./TextFieldCalendar.module.scss";

export type ChangeCalendarFormValues = {
  hour: number | null;
  minute: number | null;
  date: Date | null;
};

interface Props {
  onAccept(values: ChangeCalendarFormValues): void;
  onClose?(): void;
  defaultValues?: ChangeCalendarFormValues;
  title: string;
}

export const TextFieldCalendarModal: React.FC<Props> = ({
  onAccept,
  onClose,
  defaultValues,
  title,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    setValue,
    setError,
  } = useForm<ChangeCalendarFormValues>({
    mode: "all",
    defaultValues: defaultValues || {
      date: new Date(),
    },
  });
  const watchedDate = useWatch({
    control,
    name: "date",
  });

  const accept: SubmitHandler<ChangeCalendarFormValues> = (values) => {
    onAccept(values);
    onClose?.();
  };
  return (
    <div className={styles.modal}>
      <div className={styles.modal__container}>
        <div className="bold-24 mb-32 text-center">{title}</div>

        <div className={styles.modal__time}>
          <div className={styles.modal__time__item}>
            <TextField
              type="number"
              label="Часы"
              {...register("hour", {
                valueAsNumber: true,
                required: "Введите часы",
                min: {
                  value: 0,
                  message: "Минимум 0",
                },
                max: {
                  value: 23,
                  message: "Максимум 23",
                },
              })}
              withError
              error={errors.hour}
            />
          </div>

          <div className={styles.modal__time__item}>
            <TextField
              type="number"
              label="Минуты"
              {...register("minute", {
                valueAsNumber: true,
                required: "Введите минуты",
                min: {
                  value: 0,
                  message: "Минимум 0",
                },
                max: {
                  value: 59,
                  message: "Максимум 59",
                },
              })}
              withError
              error={errors.minute}
            />
          </div>
        </div>
        <div className={styles.modal__calendar}>
          <Controller
            control={control}
            name="date"
            rules={{
              required: "Выбериту дату",
            }}
            render={() => (
              <Calendar
                minDate={new Date()}
                className="calendar"
                onChange={(date: Date) => {
                  setValue("date", date);
                  setError("date", {
                    message: "",
                  });
                }}
                value={watchedDate}
              />
            )}
          />

          <div className={styles.error}>{errors.date?.message}</div>
        </div>
        <div className={styles.modal__buttons}>
          <AppButton
            type="button"
            onClick={handleSubmit(accept)}
            variant="siren"
          >
            Подтвердить
          </AppButton>
          <AppButton type="button" onClick={onClose} variant="siren_border">
            Закрыть
          </AppButton>
        </div>
      </div>
      <div onClick={onClose} className={styles.modal__overlay}></div>
    </div>
  );
};
